import { Payment } from "../../payments/models/Payment";
import { PaymentStatus } from "../../payments/models/PaymentStatus";

export type AttentionFilter = "drafts" | "overdue" | "notYetRecorded" | "lowBalance" | "invoiced" | "all";

export const matchesAttentionFilter = (p: Payment, filter: AttentionFilter): boolean => {
  switch (filter) {
    case "all":
      return true;
    case "drafts":
      return p.status === PaymentStatus.Draft;
    case "overdue":
      // The server already includes "Invoiced past due" in the attention list, but we
      // can't tell from the wire whether a given Invoiced row is also overdue.
      // For Phase 6 this filter shows server-classified Overdue rows only; refinement
      // (compare dueDate to today) is a UI follow-up.
      return p.status === PaymentStatus.Overdue;
    case "lowBalance":
      return p.remainingBalance !== undefined && p.remainingBalance <= 2;
    case "invoiced":
      return p.status === PaymentStatus.Invoiced;
    case "notYetRecorded":
      // notYetRecorded is row-level evidence below the table; payments don't match.
      return false;
  }
};
